import {aiDrawerViewAtom} from 'atoms/aiSearch';
import {pageDrawerOpenCountAtom} from 'atoms/pageDrawer';
import {useSetAtom} from 'jotai';
import {useEffect} from 'react';

/** Register a page-level right drawer so global UI (e.g. AI chat) can yield the rail. */
export const useRegisterPageDrawer = (open: boolean) => {
  const setCount = useSetAtom(pageDrawerOpenCountAtom);
  const setAskView = useSetAtom(aiDrawerViewAtom);

  useEffect(() => {
    if (!open) {
      return;
    }
    setCount((count) => count + 1);
    // Ask and page drawers share the right rail, so when a page drawer opens we
    // minimize Ask (if expanded) to reveal the drawer. This fires only on open,
    // not as a persistent guard, so the user can still re-expand Ask over the
    // drawer afterward via the always-visible nav chip.
    setAskView((view) => (view === 'expanded' ? 'minimized' : view));
    return () => {
      setCount((count) => Math.max(0, count - 1));
    };
  }, [open, setCount, setAskView]);
};
